import { getCities } from "../../api/SelectApi";
import InputSelect from "../InputSelect";

import { tr } from "../../i18n";
const SelectCity = ({ state_id, ...props }) => {
  const data = {
    name: props.name || "city_id",
    placeholder: tr("settings:select_city"),
    rules: props.rules,
    className: props.className,
    defaultValue: props.defaultValue,
  };

  async function handleData(search = "") {
    if (!state_id) return [];
    const result = await getCities(state_id, search);
    return result.data.map((d) => ({
      label: d.text,
      value: d.id,
    }));
  }

  return (
    <InputSelect
      key={state_id}
      props={props}
      data={data}
      handleOnLoadData={handleData}
    />
  );
};

export default SelectCity;
